<div class="row" style="color : #002E46 !important;">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay>
			  <source src="/assets/videos/sleep_and_age.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	<div class="col-md-2"></div>
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<p style="color : #002E46 !important;">
				Research shows that as we age the total amount of sleep becomes shorter. Even when provided with the same
				opportunity to sleep, older adults sleep less than younger adults.


			</p>
			<br>
			<p style="color : #002E46 !important;">
				As we get older sleep becomes lighter, making it easier to be interrupted and awakened. There is also a considerable
				decrease in the amount of deep sleep (N3), which is replaced by lighter sleep stages (N1) and (N2). It is important
				to note that for some elderly adults, 5 to6 hours, or sometime even less, may be appropriate.

			</p>
			<br>
			<p style="color : #002E46 !important;">
				In addition to the changes in sleep architecture, elderly people often encounter the following sleep problems:
			</p>
			<br>
			<ul>
				<li style="color : #002E46 !important;">
					<strong>They tend to experience more awakenings </strong>
					and for a longer time. This is caused by a variety of reasons, such as medications and concomitant medical
					conditions.

				</li>
				<br>
				<li style="color : #002E46 !important;">
					<strong>They are more prone to develop other sleep disorders</strong>
					including breathing disturbances - Obstructive Sleep apnea is an example of a breathing problem during sleep.
					Older people are often at a higher risk of breathing pauses, or apneas, during sleep due to the accumulation of
					neck fat, thyroid nodules, and the reduction in muscle tone. Post-menopausal patients are at an increased risk
					as well.
				</li>
				<br>
				<li style="color : #002E46 !important;">
					<strong> Periodic limb movements are more common</strong>
					especially if the patient is anemic. This causes them to experience “twitches” in their feet, legs and
					occasionally their arms.

				</li>
				<br>
				<li style="color : #002E46 !important;">
					<strong>Last, there are many other medical conditions </strong>
					that are commonly associated with aging that can disrupt sleep. Conditions such as prostate enlargement and
					bladder muscle hyperactivity ,which are often the main cause of frequent nocturnal awakenings. Patients with a
					cardiac history that includes events such as congestive heart failure and/or atrial fibrillation, which causes
					an irregularly irregular heart rate, are also more prone to develop another breathing disorder called central
					sleep apnea.
				</li>


			</ul>

			<mat-card style="background-color: #e9f3f1;">
				<mat-card-content>
					<mat-card-header>
						<mat-card-title style="font-weight: bold; color : #002E46 !important;" class="ion-text-center">Key Points</mat-card-title>

					</mat-card-header>

					<p style="color : #002E46 !important;">
						Realizing that changes in sleep are a common part of aging will provide you with a sense of control over
						your sleep and will make it less likely to construe these changes as insomnia. Understanding the physiology
						of sleep and understanding some of the basic facts can help us employ techniques to overcome insomnia.
						<br>
						<br>
						<strong>It is important to emphasize again that our bodies change in many ways as we get older and sleep is
							no exception.</strong>
					</p>
				</mat-card-content>
			</mat-card>
		</div>
	<div class="col-md-2"></div>
</div>


